import { Formik } from "formik";

import {
  Field,
  Form,
  Input,
  Label,
  SubmitButton,
} from "../../../../../components/forms";
import { Logo } from "../../Logo";
import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import useLoginScreen from "./useLoginScreen";

type Props = {
  onLogin: (email: string) => void;
};

export default function EmailScreen({ onLogin }: Props) {
  const { initialValues, onSubmit, schema, email } = useLoginScreen({
    onLogin,
  });

  return (
    <Panel>
      <Logo />
      <Heading>Griptonite account</Heading>
      <Intro>
        {email
          ? "We recognise you! We see you have already signed in to Griptonite before. Enter your password."
          : "Please log in with your Griptonite account to proceed."}
      </Intro>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={schema}
        validateOnChange
      >
        <Form>
          <Field name="email">
            <Label>Email address</Label>
            <Input type="email" disabled={!!email} />
          </Field>
          <Field name="password">
            <Label>Password</Label>
            <Input type="password" />
          </Field>
          <div className="mb-3 text-end">
            <a
              href="https://api.griptonite.io/auth/reset-password"
              className="text-decoration-none"
            >
              Forgotten your password?
            </a>
          </div>
          <SubmitButton>Next</SubmitButton>
        </Form>
      </Formik>
    </Panel>
  );
}
